import styled from "styled-components"

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;

  @media only screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const FieldLabel = styled.span`
  font-size: 0.75rem;
  color: #64748b;
  margin-bottom: 6px;
  font-weight: 500;
`

export const ReadOnlyValue = styled.span`
  font-size: 0.875rem;
  color: #94a3b8;
  padding: 10px 0;
`
